import axios from 'axios';

// Clara AI follow-ups of overdue payments and renewals (backend: /insurance/clara-followup/*). The
// action itself is a trigger of type clara_followup, saved through the Payments or Renewals trigger
// actions.
export default {
  namespaced: true,
  state: {
    // Clara on the open policy card (`case/for-policy`): `payments` by payment id for the row chips,
    // `line` for the line under the header. Fetched by PolicyDetailHeader, read by both.
    policyClara: { policyId: null, payments: {}, line: null },
  },
  mutations: {
    setPolicyClara(state, value) {
      state.policyClara = value;
    },
  },
  actions: {
    fetchPolicyClara({ commit }, policyId) {
      return axios.post('/insurance/clara-followup/case/for-policy', { policyId })
        .then((resp) => {
          commit('setPolicyClara', { policyId, payments: resp.data.payments || {}, line: resp.data.line || null });
        })
        .catch(() => {
          commit('setPolicyClara', { policyId, payments: {}, line: null });
        });
    },
    clearPolicyClara({ commit }) {
      commit('setPolicyClara', { policyId: null, payments: {}, line: null });
    },
    // "Why it's here" for a ticket; the response has no `case` when the ticket isn't Clara's.
    caseByTicket(_, ticketId) {
      return axios.post('/insurance/clara-followup/case/by-ticket', { ticketId });
    },
    takeOver(_, ticketId) {
      return axios.post('/insurance/clara-followup/case/take-over', { ticketId });
    },
    stopCase(_, ticketId) {
      return axios.post('/insurance/clara-followup/case/stop', { ticketId });
    },
    clientStatus(_, personProfileId) {
      return axios.post('/insurance/clara-followup/client/status', { personProfileId });
    },
    // Either `personProfileId` (client profile) or `ticketId` (from a ticket).
    toggleClient(_, { enabled, personProfileId, ticketId }) {
      return axios.post('/insurance/clara-followup/client/toggle', { enabled, personProfileId, ticketId });
    },
    // `hub` is PAYMENTS (default) or RENEWALS.
    preview(_, {
      settings, language, clientName, hub,
    } = {}) {
      return axios.post('/insurance/clara-followup/preview', {
        settings, language, clientName, hub,
      });
    },
    // Renewals also send `actionStage` and the stage timer (`dueDateTimer`, seconds).
    eligibleCount(_, {
      settings, hub, actionStage, dueDateTimer,
    } = {}) {
      return axios.post('/insurance/clara-followup/eligible-count', {
        settings, hub, actionStage, dueDateTimer,
      });
    },
    sendTest(_, { settings, hub } = {}) {
      return axios.post('/insurance/clara-followup/send-test', { settings, hub });
    },
    // The latest renewal case of each policy, for the chips on the Renewals board.
    casesByPolicies(_, policyIds) {
      return axios.post('/insurance/clara-followup/case/by-policies', { policyIds });
    },
  },
};
